import {deviceData} from "../../dataInterface/deviceDetailInterface";


interface customerDevices {
    type:string
    payload:deviceData
}

export default (state = null, action:customerDevices) => {
    switch (action.type) {
        case "CUSTOMER_DEVICES":
            return action.payload;
        default:
            return state;
    }
};
